export { default as RootPage } from './Root';
export { default as GerminationPage } from './Germination';
export { default as HealingPage } from './Healing';
export { default as GreenhousePage } from './Greenhouse';
export { default as VehiclePage } from './Vehicle';
export { default as TrayPage } from './Tray';
